import React, { memo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getChangeShowsTemporalIntervalAction } from "../../store/actionCreators";
import { ShowsFilterContentWrapper } from "./style";
import { Affix } from "antd";
import KTFilterContentHeader from "@/components/filter/filter-content-header";
import KTFilterContentDateRange from "@/components/filter/filter-content-date-range";
import { showsFilterDateIntervals } from "../../local-data";

const KTShowsFilterContent = memo(({ onClose }) => {
  const dispatch = useDispatch();
  const { intervalType, startdt, enddt } = useSelector(
    (state) => ({
      intervalType: state.getIn(["shows", "intervalType"]),
      startdt: state.getIn(["shows", "startdt"]),
      enddt: state.getIn(["shows", "enddt"]),
    }),
    shallowEqual
  );

  function onChangeIntervalValue(ele) {
    dispatch(
      getChangeShowsTemporalIntervalAction(ele.value, ele.startdt, ele.enddt)
    );
  }

  function onResetClick() {
    dispatch(getChangeShowsTemporalIntervalAction("0", undefined, undefined));
  }

  return (
    <ShowsFilterContentWrapper>
      <Affix offsetTop={0}>
        <KTFilterContentHeader onClose={onClose} onReset={onResetClick} />
      </Affix>

      <KTFilterContentDateRange
        dateIntervals={showsFilterDateIntervals}
        startdt={startdt}
        enddt={enddt}
        selectedIntervalValue={intervalType}
        didIntervalValueChange={onChangeIntervalValue}
      />
    </ShowsFilterContentWrapper>
  );
});

export default KTShowsFilterContent;
